import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e64f302"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel",
  style: {"gap":"8px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Mail ID", -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client ID", -1))
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client Secret", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Tenant ID", -1))
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Scope", -1))
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Log Level", -1))
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "API Base-URL", -1))
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "save-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IciButton = _resolveComponent("IciButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.mailId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mailId) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.clientId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.clientId) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.clientSecret,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clientSecret) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.tenantId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tenantId) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.scope,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scope) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.logLevel,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.logLevel) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.apiBaseUrl,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.apiBaseUrl) = $event)),
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_IciButton, {
        id: "submit",
        content: "Save",
        onButtonClick: this.save,
        btnStyle: "width: 140px;",
        dark: true
      }, null, 8, ["onButtonClick"])
    ])
  ]))
}